//import React from "react";
import React, { useEffect, useContext } from 'react';
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import CsvDownloader from 'react-csv-downloader';

// react component
import ReactTable from "react-table";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import FormControl from "@material-ui/core/FormControl";
import Select from "react-select";
import { ValidSelect } from "beaktShared/helpers/validselect";
import FormHelperText from "@material-ui/core/FormHelperText";

// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import Search from "@material-ui/icons/Search";
import Edit from "@material-ui/icons/Edit";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";
import { GerenciaModal } from "beaktShared/views/Crud/ModalDetail";
import GestaCliente from "./GestaoCliente";

// services
import moment from "moment";
import {MaskCPF, formateDate} from "beaktShared/helpers/masks";
import { SessionContext } from "beaktShared/services/session";
import { UseGetApiSimple,UsePostApi } from "beaktShared/services/crudeApiService";

// styles
import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
const useStyles = makeStyles(styles);

export default function GestaoClienteList({callUpdateScrollTOP}) {
    const { t } = useTranslation();
    const classes = useStyles();
    const endPoint = 'clientes/';  
    const session = useContext(SessionContext);  
    const { register, getValues, setValue, clearError, setError, errors } = useForm({mode: "onChange"});

    const [showFormView, setshowFormView] = React.useState(false);
    const [item, setItem] = React.useState({});          
    const [loadingForm, setLoadingForm] = React.useState(false);
    const [notification, setNotification] = React.useState({
        show:false,
        color:'info',
        message:''
    });
    const showNotification = (message,color) => { 
        setNotification({
        show:true,
        color:color,
        message:message      
        });
        setTimeout(function() {
        setNotification({show:false});
        }, 6000);       
    };

    const [aniversario, setaniversario] = React.useState();
    const [aniversarioList, setaniversarioList] = React.useState([        
        {desc: "Selecione", value: null},
        {desc: "Janeiro", value: 1},
        {desc: "Fevereiro", value: 2},
        {desc: "Março", value: 3},
        {desc: "Abril", value: 4},
        {desc: "Maio", value: 5},
        {desc: "Junho", value: 6},
        {desc: "Julho", value: 7},
        {desc: "Agosto", value: 8},
        {desc: "Setembro", value: 9},
        {desc: "Outubro", value: 10},
        {desc: "Novembro", value: 11},
        {desc: "Dezembro", value: 12}
    ]);
    const handleAniversarioChange = value => {
        setaniversario(value);
        setValue("aniversario", value);          
    };

    useEffect(() => {
        verifyAcess();
    }, []);

    const verifyAcess = () =>{
        if(session.estabelecimentoId === 0) //Acessando tela pelo modulo matriz
        {
            setshowSelectEstabelecimentos(true);
            LoadEstabelecimentos();  
        }
        else //Acessando tela pelo modulo Clinica   
        {
            setestabelecimentos([session.estabelecimentoId]);//usado para enviar na requisição de consulta da lista de clientes na tela de lista
            setestabelecimentosId(session.estabelecimentoId)//usado para enviar na abertura do formulario handleEdit
            setshowSelectEstabelecimentos(false)
            setacessoEstabelecimento(true);
        }
    }

    const [showSelectEstabelecimentos, setshowSelectEstabelecimentos] = React.useState(true);
    const [isLoadingEstabelecimento, setisLoadingEstabelecimento] = React.useState(false);
    const [listSelectEstabelecimentos, setlistSelectEstabelecimentos] = React.useState([]);
    const [estabelecimentosId, setestabelecimentosId] = React.useState(0);
    const [estabelecimentosDesc, setestabelecimentosDesc] = React.useState();
    const [listSelectEstabelecimentosSelected, setlistSelectEstabelecimentosSelected] = React.useState([]);
    const [estabelecimentos, setestabelecimentos] = React.useState([]);
    const LoadEstabelecimentos = () => {
        setisLoadingEstabelecimento(true);
        const endPoint = "estabelecimentos/ativos/byfranquia/"+session.franquiaId;
        UseGetApiSimple(endPoint, 0).then(result => {
        if (result.status !== 200) {
            showNotification(result.message, 'error')
            setisLoadingEstabelecimento(false);
            return false;
        }

        setisLoadingEstabelecimento(false);
        setlistSelectEstabelecimentos(result.data);  

        return true;
        });
    };
    const handleEstabelecimentoChange = event => {
        let value = event

        let lstsAdd = [];
        let lstSelect = [];
        value.map(item =>{
             lstsAdd.push(item.estabelecimentoId); 
            
            lstSelect.push({
                estabelecimentoId:item.estabelecimentoId
            });                   
        });
         setestabelecimentos(lstsAdd); 
        setlistSelectEstabelecimentosSelected(lstSelect);
    }
    const handleClickSelecionarTodosEstabelecimentos = () =>{
        
        let lstsAdd = [];
        let lstSelect = [];
        listSelectEstabelecimentos.map(item =>{
            lstsAdd.push(item.estabelecimentoId); 
            
            lstSelect.push({
                estabelecimentoId: item.estabelecimentoId
            });                   
        });
        setestabelecimentos(lstsAdd); 
        setlistSelectEstabelecimentosSelected(lstSelect);
    }
    const [selectCPF, setselectCPF] = React.useState("");
    const [selectNOME, setselectNOME] = React.useState("");
    const [selectEMAIL, setselectEMAIL] = React.useState("");
    const [selectANIVERSARIO, setselectANIVERSARIO] = React.useState(0);

    const handleClickPesquisa = () =>{       
        let data = getValues();

        setselectCPF(data.cpf)
        setselectNOME(data.nome)
        setselectEMAIL(data.email)
        setselectANIVERSARIO(data.aniversario)

        if (estabelecimentos.length === 0)
            return setError("estabelecimentos", "required")

        if(data.nome === "" && data.cpf === "" && data.email === "" && data.aniversario == null)
        {
            showNotification(t('information_message.fill_in_the_name'), 'danger')
            return false;
        }
            
        let obj = {
            nome:data.nome === '' ? '*' : data.nome,
            cpf:data.cpf === '' ? '*' : data.cpf,
            email:data.email === '' ? '*' : data.email,
            aniversario: data.aniversario == null ? '0' : data.aniversario,
            estabelecimentos:estabelecimentos
        };

        loadClientes(obj);          
    }
    // constante para determinar se vai exibir o botão de TODOS CLIENTES
    const [acessoEstabelecimento, setacessoEstabelecimento] = React.useState(false);
    
    const handleClickTodosClientes = () =>{  

        let data = getValues(); 
      
        let obj = {
            nome:data.nome === '' ? '*' : data.nome,
            cpf:data.cpf === '' ? '*' : data.cpf,
            email:data.email === '' ? '*' : data.email,
            aniversario: data.aniversario == null ? '0' : data.aniversario,
            estabelecimentos:estabelecimentos
        };

        loadClientes(obj); 
    }
    const [isLoadingList, setisLoadingList] = React.useState(false);
    const [list, setListAtualiza] = React.useState([]);
    const loadClientes = (obj) =>{ 
        let _endPointGet= endPoint + 'GetClienteFilter/';
        
        setisLoadingList(true);
        UsePostApi(_endPointGet,obj).then(result=>{
            if(result.status !== 200)
            {   
                showNotification(result.message, 'danger')
                setisLoadingList(false);
                return false; 
            }
            setListAtualiza(result.data); 
            loadDataCsv(result.data);
            setisLoadingList(false);  
            return true;             
        });    
    }

    const handleAdd = item => {

        var vefifyExists = list.filter(obj => {
            return obj.clienteId === item.clienteId;
        });

        if(vefifyExists.length > 0)
        {
            const updateList = list.map(l => (l.clienteId === item.clienteId ? item : l));
            setListAtualiza(updateList);
        }
        else
        {
            const addItemList = [...list, item];
            setListAtualiza(addItemList); 
        }
        return false;        
    }; 

    const handleView = (resetItem) => {  

        if(resetItem)
            setItem({});
        let show = showFormView === true ? false : true;

        setshowFormView(show);    
        callUpdateScrollTOP();

        let obj = {
            nome:selectNOME === '' ? '*' : selectNOME,
            cpf:selectCPF === '' ? '*' : selectCPF,
            email:selectEMAIL === '' ? '*' : selectEMAIL,
            aniversario: selectANIVERSARIO == null ? '0' : selectANIVERSARIO,
            estabelecimentos:estabelecimentos
        };

        loadClientes(obj); 
    };

    const [detailModal, setConfModal] = GerenciaModal();
    const handleDetail = row => {  
        
        const bodyDetail=(
         <div>
             <p><b>{t('label.name')}: </b>{row.nome}</p> 
             <p><b>{t('label.email')}: </b>{row.email}</p> 
             <p><b>{t('label.status')} </b>{row.ativo === true ? t('label.active') : t('label.inactive')}</p> 
             <p><b>{t('label.cpf')}: </b>{row.cpf ? row.cpf : t('information_message.uninformed')}</p> 
             <p><b>{t('label.rg')}: </b>{row.rg ? row.rg :  t('information_message.uninformed')}</p> 
             <p><b>{t('label.date_of_birth')}: </b>{ row.dataNascimento !== null ? formateDate(row.dataNascimento) :  t('information_message.uninformed') }</p> 
             <p><b>{t('label.gender')}: </b>{ row.sexo !== null && row.sexo === 0 ? t('label.female') : row.sexo !== null && row.sexo === 1 ? t('label.male') : t('information_message.uninformed') }</p> 
             <p><b>{t('label.cell_phone')}: </b>{row.celular ? row.celular : t('information_message.uninformed')}</p> 
        </div>
        );

        setConfModal({
            showmodal: true,
            dataShow: bodyDetail
          });
    };

    const handleEdit = row => {   
        let _endPointGet = endPoint + row.clienteId ;
        UseGetApiSimple(_endPointGet).then(result=>{   
            if(result.status !== 200)
            {   
                showNotification(result.message, 'danger')
                return false; 
            }
            setItem(result.data);
            handleView(false);
        });  
    };

    const columnsProp = [{
        Header: t('label.establishment'),
        accessor: "estabelecimentoDescricao",
    },
    {
        Header: t('label.name'),
        accessor: "nome"
    },
    {
        Header: t('label.email'),
        accessor: "email"
    },
    {
        Header: t('label.cell_phone'),
        accessor: "celular"
    },
    {
        Header: t('label.cpf'),
        accessor: "cpf"
    },
    {
        Header: t('label.date_of_birth'),
        accessor: "dataNascimento",
        Cell : (props)=>{
            const custom_date = props.value == null ? "" : formateDate(props.value)
            return <span>{custom_date}</span>
        }
    }]

    const columnsAcao = [        
    {
        Header: t('label.actions'),
        Cell: row => (
            <div className="actions-right">                        
            <Button
                justIcon
                round
                simple                            
                color="info"
                className="info"
                onClick={() => handleDetail(row.original)}
            >
                <Search />
            </Button>{" "}
            <Button
                justIcon
                round
                simple
                color="success"
                className="edit"
                onClick={() => handleEdit(row.original)}
            >
                <Edit />
            </Button>{" "}
        </div>
        ),
        sortable: false,
        filterable: false
    }
    ];
    const columns = [...columnsProp,...columnsAcao]  

    const [dataCSV,setdataCSV] = React.useState([]);  
    const columnsCSV = [
        {id:'estabelecimentoDescricao', displayName: 'Estabelecimentos'},
        {id: 'dataCadastro', displayName: 'Data cadastro'},
        {id: 'cpf', displayName: 'CPF'}, 
        {id: 'nome', displayName: 'Nome'}, 
        {id: 'email', displayName: 'Email'}, 
        {id: 'celular', displayName: 'Celular'}, 
        {id: 'dataNascimento', displayName: 'Aniversário'},
        {id: 'idade', displayName: 'Idade'},
        {id: 'sexo', displayName: 'Sexo'},
        {id: 'rua', displayName: "Rua"},
        {id: 'numero', displayName: "Número"},
        {id: 'cidade', displayName: 'Cidade'},
        {id: 'bairro', displayName: 'Bairro'},
        {id: 'estado', displayName: 'Estado'},
        {id: 'cep', displayName: 'CEP'},
        {id: 'profissaoDescricao', displayName: 'Profissão'},
        {id: 'canalMidia', displayName: 'Canal de mídia'}
    ];
    const loadDataCsv = (data) =>{
        let dtCsv = [];

        data.map(item =>{
            var obj = {
                estabelecimentoDescricao: item.estabelecimentoDescricao,
                dataCadastro: item.dataCadastro,
                cpf: item.cpf,
                nome: item.nome,
                email: item.email,
                celular: item.celular,
                dataNascimento: (item.dataNascimento == null ? "" : formateDate(item.dataNascimento)),
                idade: item.idade,
                sexo: item.sexoDescricao,
                rua: item.rua,
                numero: item.numero,
                cidade: item.cidade,
                bairro: item.bairro,
                estado: item.estado,
                cep: item.cep,
                profissaoDescricao: item.profissaoDescricao,
                canalMidia: item.canalMidia,
            };
            dtCsv.push(obj);
        })

        setdataCSV(dtCsv);
    }

    return (
        <div>

            <Snackbar
                place="tr"
                color={notification.color}
                message={notification.message}
                open={notification.show}
                closeNotification={() => setNotification({show:false})}
                close
            />

            {showFormView && 
             <GestaCliente addItem={handleAdd} item={item} handleView={handleView} loading={loadingForm} estabelecimentoId={estabelecimentosId} />
            } 
            
            {!showFormView  &&
            <div>
                <GridContainer>   
                             
                <GridItem xs={12}>
                    <Card>
                        <CardHeader color="primary" icon>
                            <CardIcon color="primary">
                                <Assignment />
                            </CardIcon>
                            <h4 className={classes.cardIconTitle}>{t('sidebar.client_management')} </h4>
                        </CardHeader>
                        <CardBody>

                        <form> 
                        {showSelectEstabelecimentos &&                        
                        <GridContainer> 
                            <GridItem xs={12} sm={12} md={12}>               
                                <FormControl fullWidth className={classes.formControl} style={{marginBottom:'20px'}}>
                                <label className={errors.estabelecimentos ? "select__label select__label_error" : "select__label"}>{t('label.establishment')+" *"} </label>
                                <Select
                                    classNamePrefix="select"
                                    styles={ValidSelect(errors.estabelecimentos ? true : false)}
                                    isMulti={true}    
                                    isLoading={isLoadingEstabelecimento}
                                    name="estabelecimento"
                                    placeholder="Selecione..."
                                    options={listSelectEstabelecimentos}
                                    getOptionLabel={({ descricao }) => descricao}
                                    getOptionValue={({ estabelecimentoId }) => estabelecimentoId}
                                    value={listSelectEstabelecimentos.filter(({estabelecimentoId}) => estabelecimentos.indexOf(estabelecimentoId) != -1)}
                                    onChange={(value) => handleEstabelecimentoChange(value || [])}                                      
                                    ref={() => register({ name: "estabelecimento" })}
                                />
                                {errors.estabelecimentos &&
                                <FormHelperText>
                                    <span className="obg">{t('label.select_an_establishment')} </span>
                                </FormHelperText>}

                                <div style={{textAlign:'right',marginTop:'3px'}}>
                                    <a href="#"  onClick={() => handleClickSelecionarTodosEstabelecimentos()} style={{marginTop:'10px'}}>
                                    {t('label.select_all_establishments')}
                                    </a>
                              </div>
                                </FormControl>                    
                        </GridItem>
                        </GridContainer>}  
                        <GridContainer>     
                            <GridItem xs={12} sm={6} md={6}> 
                                <FormControl fullWidth className={classes.formControl}>                               
                                <TextField                                        
                                    label={t('label.name')}
                                    variant="outlined"
                                    name="nome"
                                    InputLabelProps={{shrink: true}}        
                                    inputRef={register({required: false})}
                                    autoComplete="off"
                                />
                                </FormControl>                                 
                            </GridItem>
                            <GridItem xs={12} sm={6} md={6}> 
                                <FormControl fullWidth className={classes.formControl}>                               
                                <TextField                                        
                                    label={t('label.email')}
                                    variant="outlined"
                                    name="email"
                                    InputLabelProps={{shrink: true}}        
                                    inputRef={register({required: false})}
                                    autoComplete="off"
                                />
                                </FormControl>                                 
                            </GridItem>
                            <GridItem xs={12} sm={3} md={3}> 
                                <FormControl fullWidth className={classes.formControl}>                               
                                <TextField                                        
                                    label={t('label.cpf')}
                                    variant="outlined"
                                    name="cpf"
                                    InputLabelProps={{shrink: true}}     
                                    inputRef={register({required: false})}   
                                    autoComplete="off"
                                    InputProps={{
                                        inputComponent: MaskCPF
                                    }}     
                                />
                                </FormControl>                                 
                            </GridItem>
                            <GridItem xs={12} sm={3} md={3}>                
                                <FormControl fullWidth className={classes.formControl}>
                                <label className={"select__label"}>
                                    {t('label.date_of_birth')}</label>
                                <Select
                                    classNamePrefix="select"
                                    styles={ValidSelect(errors.aniversario ? true : false)}
                                    isSearchable={true}                                    
                                    name="aniversario"
                                    placeholder={t('label.select')+"..."}
                                    options={aniversarioList}
                                    value={aniversarioList.filter(({ value }) => value === aniversario)}
                                    getOptionLabel={({ desc }) => desc}
                                    getOptionValue={({ value }) => value}
                                    onChange={(value) => handleAniversarioChange(value.value !== null ? value.value : "0")}
                                    ref={() => register({ name: "aniversario" })
                                    }
                                />                                
                                </FormControl>                    
                            </GridItem>                              
                            <GridItem xs={6} sm={2} md={2}>                             
                                <Button round color="primary"  onClick={e => { handleClickPesquisa()}}>
                                    {t('label.search')}
                                </Button>                                 
                            </GridItem> 
                            {acessoEstabelecimento &&
                                <GridItem xs={6} sm={2} md={2}>                             
                                <Button round color="info"  onClick={e => { handleClickTodosClientes()}}>
                                    {'Todos Clientes'}
                                </Button>                                 
                            </GridItem> 
                            }
                        </GridContainer>  
                        </form>
                        {dataCSV.length > 0 &&
                            <div>
                                <div style={{float:'right'}}>
                                <CsvDownloader
                                filename="report"
                                columns={columnsCSV}
                                datas={dataCSV}
                                separator={";"}>
                                    <Button  round color="default" size="sm" >CSV</Button> 
                                </CsvDownloader>
                                </div><div style={{clear:'both'}}></div>
                            </div>
                        }
                        <ReactTable
                            loading = {isLoadingList}
                            data={list}
                            columns={columns}
                            filterable={false}
                            defaultPageSize={10}
                            minRows={5}
                            showPaginationBottom={true}
                            className="-striped -highlight"
                            previousText={t('button.previous')}
                            nextText={t('button.next')}
                            loadingText={t('label.loading')+"..."}
                            noDataText={t('information_message.no_records_found')+"!"}
                            pageText={t('label.page')}
                            ofText={t('label.of')}
                            rowsText={t('label.rows')}
                        />
                        </CardBody>
                    </Card>
                </GridItem>            
            </GridContainer>
            </div>
            }
            {detailModal}            
        </div>
    );
}